(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-pro-hair-concerns"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (section.dataset.proHairConcernsInit === '1') return;
    section.dataset.proHairConcernsInit = '1';

    var tabs = section.querySelectorAll('[data-pro-hair-concerns-tab]');
    var panels = section.querySelectorAll('[data-pro-hair-concerns-panel]');
    var cta = section.querySelector('[data-pro-hair-concerns-cta]');

    function activate(idx) {
      Array.prototype.forEach.call(tabs, function (t) {
        var isActive = parseInt(t.getAttribute('data-target'), 10) === idx;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      Array.prototype.forEach.call(panels, function (p) {
        var isActive = parseInt(p.getAttribute('data-index'), 10) === idx;
        p.classList.toggle('is-active', isActive);
        p.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive && cta) {
          var href = p.getAttribute('data-cta-href');
          if (href) cta.setAttribute('href', href);
        }
        if (isActive && typeof p.__updateNavState === 'function') {
          requestAnimationFrame(p.__updateNavState);
        }
      });
    }

    Array.prototype.forEach.call(tabs, function (t) {
      t.addEventListener('click', function () {
        var idx = parseInt(t.getAttribute('data-target'), 10) || 0;
        activate(idx);
      });
    });

    Array.prototype.forEach.call(panels, function (panel) {
      var list = panel.querySelector('[data-pro-hair-concerns-list]');
      var prev = panel.querySelector('[data-pro-hair-concerns-prev]');
      var next = panel.querySelector('[data-pro-hair-concerns-next]');
      if (!list) return;

      function step() {
        var first = list.querySelector('.pro-hair-concerns__item');
        if (!first) return list.clientWidth;
        var styles = window.getComputedStyle(list);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function updateNavState() {
        if (!prev || !next) return;
        // Skip while panel is hidden (clientWidth=0 collapses max to -1 and stuck-disables next).
        if (list.clientWidth === 0) return;
        var max = list.scrollWidth - list.clientWidth - 1;
        prev.disabled = list.scrollLeft <= 1;
        next.disabled = list.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () {
        list.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        list.scrollBy({ left: step(), behavior: 'smooth' });
      });

      list.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      panel.__updateNavState = updateNavState;
      updateNavState();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pro-hair-concerns]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pro-hair-concerns]');
    if (s) initSection(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    var slides = section.querySelectorAll('[data-pro-hero-slide]');
    var dots = section.querySelectorAll('[data-pro-hero-dot]');
    if (!slides.length || slides.length <= 1) return;

    var current = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(section.getAttribute('data-interval'), 10) || 5000;
    var timer = null;

    function setSlideState(idx, active) {
      slides[idx].classList.toggle('is-active', active);
      slides[idx].setAttribute('aria-hidden', active ? 'false' : 'true');
      var link = slides[idx].querySelector('.pro-hero__slide-link');
      if (link) link.setAttribute('tabindex', active ? '0' : '-1');
      if (dots[idx]) {
        dots[idx].classList.toggle('is-active', active);
        dots[idx].setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }

    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      if (i === current) return;
      setSlideState(current, false);
      current = i;
      setSlideState(current, true);
    }

    function next() { go(current + 1); }
    function prev() { go(current - 1); }
    function start() { stop(); if (autoplay) timer = window.setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    Array.prototype.forEach.call(dots, function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-target'), 10) || 0;
        go(i);
        start();
      });
    });

    var main = section.querySelector('[data-pro-hero-main]');
    if (main) {
      var startX = 0;
      var startY = 0;
      var dragging = false;
      var moved = false;
      var THRESHOLD = 40;

      main.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startY = e.clientY;
        stop();
      });

      main.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          moved = true;
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        var dx = (e.clientX || 0) - startX;
        if (moved && Math.abs(dx) > THRESHOLD) {
          if (dx < 0) next(); else prev();
        }
        start();
      }

      main.addEventListener('pointerup', endDrag);
      main.addEventListener('pointercancel', function () { dragging = false; start(); });
      main.addEventListener('pointerleave', function (e) { if (dragging) endDrag(e); });

      main.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      main.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);

    start();
  }

  function initAll() {
    var sections = document.querySelectorAll('.pro-hero');
    Array.prototype.forEach.call(sections, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.pro-hero');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (section.dataset.proIngredientsInit === '1') return;
    section.dataset.proIngredientsInit = '1';
    var dialog = section.querySelector('.pro-ingredients-dialog');
    if (!dialog) return;
    var openers = section.querySelectorAll('[data-pro-ingredients-open]');
    var closers = section.querySelectorAll('[data-pro-ingredients-close]');

    var savedScrollY = 0;

    function lockScroll() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('pro-ingredients-dialog-open');
      document.body.classList.add('pro-ingredients-dialog-open');
      document.body.style.top = '-' + savedScrollY + 'px';
    }
    function unlockScroll() {
      document.documentElement.classList.remove('pro-ingredients-dialog-open');
      document.body.classList.remove('pro-ingredients-dialog-open');
      document.body.style.top = '';
      window.scrollTo(0, savedScrollY);
    }

    function open() {
      lockScroll();
      if (typeof dialog.showModal === 'function') {
        try { dialog.showModal(); } catch (e) {}
      } else {
        dialog.setAttribute('open', '');
      }
    }
    function close() {
      try { dialog.close(); } catch (e) { dialog.removeAttribute('open'); }
      unlockScroll();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    /* click outside the inner panel closes */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });
    dialog.addEventListener('cancel', close);
    dialog.addEventListener('close', unlockScroll);
  }

  function initAll() {
    document.querySelectorAll('.pro-ingredients').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      var s = e.target.querySelector('.pro-ingredients');
      if (s) initSection(s);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-journey"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (section.dataset.proJourneyInit === '1') return;
    section.dataset.proJourneyInit = '1';

    var slides = section.querySelectorAll('[data-pro-journey-slide]');
    var dots = section.querySelectorAll('[data-pro-journey-dot]');
    if (!slides.length || slides.length <= 1) return;

    var current = 0;

    function setSlideState(idx, active) {
      slides[idx].classList.toggle('is-active', active);
      slides[idx].setAttribute('aria-hidden', active ? 'false' : 'true');
      var link = slides[idx].querySelector('.pro-journey__slide-link');
      if (link) link.setAttribute('tabindex', active ? '0' : '-1');
      if (dots[idx]) {
        dots[idx].classList.toggle('is-active', active);
        dots[idx].setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }

    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      if (i === current) return;
      setSlideState(current, false);
      current = i;
      setSlideState(current, true);
    }
    function next() { go(current + 1); }
    function prev() { go(current - 1); }

    Array.prototype.forEach.call(dots, function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-target'), 10) || 0;
        go(i);
      });
    });

    var main = section.querySelector('[data-pro-journey-main]');
    if (main) {
      var startX = 0;
      var startY = 0;
      var dragging = false;
      var moved = false;
      var THRESHOLD = 40;

      main.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startY = e.clientY;
        try { main.setPointerCapture(e.pointerId); } catch (_) {}
      });

      main.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          moved = true;
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        var dx = (e.clientX || 0) - startX;
        if (moved && Math.abs(dx) > THRESHOLD) {
          if (dx < 0) next(); else prev();
        }
        try { main.releasePointerCapture(e.pointerId); } catch (_) {}
      }

      main.addEventListener('pointerup', endDrag);
      main.addEventListener('pointercancel', function (e) {
        dragging = false;
        try { main.releasePointerCapture(e.pointerId); } catch (_) {}
      });

      main.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      main.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pro-journey]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pro-journey]');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-product-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  var loadingButtons = [];

  function clearLoadingButtons() {
    while (loadingButtons.length) {
      var b = loadingButtons.pop();
      b.classList.remove('is-loading');
    }
  }

  function watchCartDrawer() {
    var drawer = document.querySelector('.cart_drawer');
    if (!drawer) return;
    var observer = new MutationObserver(function () {
      if (drawer.classList.contains('drawer_is_open')) clearLoadingButtons();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pro-card__atc');
    if (!btn || btn.disabled) return;
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    loadingButtons.push(btn);
    setTimeout(function () { btn.classList.remove('is-loading'); }, 6000);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartDrawer);
  } else {
    watchCartDrawer();
  }

  function init(section) {
    var list = section.querySelector('[data-pro-row-list]');
    var prev = section.querySelector('[data-pro-row-prev]');
    var next = section.querySelector('[data-pro-row-next]');
    if (!list) return;

    function step() {
      var first = list.querySelector('.pro-row__item');
      if (!first) return list.clientWidth;
      var styles = window.getComputedStyle(list);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateNavState() {
      if (!prev || !next) return;
      var max = list.scrollWidth - list.clientWidth - 1;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        list.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        list.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    list.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);

    updateNavState();
  }

  function initAll() {
    var sections = document.querySelectorAll('.pro-row');
    Array.prototype.forEach.call(sections, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.pro-row');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (section.dataset.proResultsInit === '1') return;
    section.dataset.proResultsInit = '1';

    var list = section.querySelector('[data-pro-results-list]');
    var prev = section.querySelector('[data-pro-results-prev]');
    var next = section.querySelector('[data-pro-results-next]');
    if (!list) return;

    function step() {
      var first = list.querySelector('.pro-results__item');
      if (!first) return list.clientWidth;
      var styles = window.getComputedStyle(list);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateNavState() {
      if (!prev || !next) return;
      var max = list.scrollWidth - list.clientWidth - 1;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      list.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      list.scrollBy({ left: step(), behavior: 'smooth' });
    });

    list.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);
    window.addEventListener('load', updateNavState);

    Array.prototype.forEach.call(list.querySelectorAll('img'), function (img) {
      if (img.complete) return;
      img.addEventListener('load', updateNavState, { once: true });
      img.addEventListener('error', updateNavState, { once: true });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateNavState).observe(list);
    }

    requestAnimationFrame(updateNavState);
  }

  function initAll() {
    document.querySelectorAll('[data-pro-results]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pro-results]');
    if (s) initSection(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.psvInit === '1') return;
    section.dataset.psvInit = '1';

    var sectionId = section.dataset.sectionId;
    var dialog = document.getElementById('psv-dialog-' + sectionId);
    if (!dialog) return;

    var slides    = dialog.querySelector('[data-sv-slides]');
    var muteBtns  = dialog.querySelectorAll('[data-sv-mute]');
    var prevBtn   = dialog.querySelector('[data-sv-prev]');
    var nextBtn   = dialog.querySelector('[data-sv-next]');
    var closeBtns = dialog.querySelectorAll('[data-sv-close]');
    var cards     = section.querySelectorAll('[data-sv-card]');

    if (!slides) return;

    var allSlides   = Array.prototype.slice.call(slides.querySelectorAll('.psv-dialog__slide'));
    var activeIndex = 0;
    var observer    = null;

    /* ---- Helpers ---- */

    function getVideo(slide) {
      return slide ? slide.querySelector('spectrum-video') : null;
    }

    function safeCall(el, method) {
      if (el && typeof el[method] === 'function') {
        try { el[method](); } catch (e) {}
      }
    }

    function getActiveVideo() {
      return getVideo(allSlides[activeIndex]);
    }

    function isDesktop() {
      return window.innerWidth > 749;
    }

    function getCurrency() {
      try {
        if (window.Spectrum && typeof window.Spectrum.getActiveCurrency === 'function') {
          return window.Spectrum.getActiveCurrency() || 'USD';
        }
      } catch (e) {}
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    }

    function trackEvent(name, props) {
      try {
        if (window.__spectrumAi && window.__spectrumAi.analytics && typeof window.__spectrumAi.analytics.trackEvent === 'function') {
          window.__spectrumAi.analytics.trackEvent(name, props);
        }
      } catch (e) {}
    }

    function entityFromAtcButton(btn) {
      if (!btn) return { product: null, variant: null };
      var amount = parseInt(btn.dataset.priceAmount, 10);
      if (isNaN(amount)) amount = 0;
      var currencyCode = getCurrency();
      return {
        product: btn.dataset.productId
          ? {
              id: String(btn.dataset.productId),
              handle: btn.dataset.productHandle || '',
              title: btn.dataset.productTitle || '',
              url: btn.dataset.productUrl || '',
              price: { amount: amount, currencyCode: currencyCode },
              image: btn.dataset.productImage || ''
            }
          : null,
        variant: btn.dataset.variantId
          ? {
              id: String(btn.dataset.variantId),
              title: btn.dataset.variantTitle || '',
              price: { amount: amount, currencyCode: currencyCode },
              sku: btn.dataset.variantSku || ''
            }
          : null
      };
    }

    function trackPlay(idx) {
      var slide = allSlides[idx];
      if (!slide) return;
      var atcBtn = slide.querySelector('[data-sv-atc]');
      var entity = entityFromAtcButton(atcBtn);
      var videoUrl = atcBtn ? (atcBtn.dataset.videoUrl || '') : '';
      trackEvent('shoppable_video_play', Object.assign({}, entity, {
        videoUrl: videoUrl,
        __spectrumVariant: 'spectrum-ai'
      }));
    }

    /* ---- Mute ---- */

    function updateMuteIcons() {
      var active = getActiveVideo();
      var isMuted = active ? active.muted : true;
      if (!muteBtns || !muteBtns.length) return;
      Array.prototype.forEach.call(muteBtns, function (btn) {
        var iconMuted = btn.querySelector('.psv-icon-muted');
        var iconSound = btn.querySelector('.psv-icon-sound');
        if (isMuted) {
          if (iconMuted) iconMuted.style.display = '';
          if (iconSound) iconSound.style.display = 'none';
          btn.setAttribute('aria-label', 'Unmute video');
        } else {
          if (iconMuted) iconMuted.style.display = 'none';
          if (iconSound) iconSound.style.display = '';
          btn.setAttribute('aria-label', 'Mute video');
        }
      });
    }

    Array.prototype.forEach.call(muteBtns, function (btn) {
      btn.addEventListener('click', function () {
        var active = getActiveVideo();
        if (!active) return;
        if (active.muted) { safeCall(active, 'unmute'); }
        else { safeCall(active, 'mute'); }
        updateMuteIcons();
      });
    });

    /* ---- Desktop position-based carousel ---- */

    function updatePositions(newIdx) {
      activeIndex = newIdx;
      allSlides.forEach(function (slide, i) {
        var diff = i - newIdx;
        var pos = diff === 0 ? 'center' : diff === -1 ? 'left' : diff === 1 ? 'right' : 'hidden';
        slide.dataset.position = pos;

        var vid = getVideo(slide);
        if (!vid) return;
        if (pos === 'center') {
          safeCall(vid, 'play');
        } else if (pos === 'hidden') {
          safeCall(vid, 'unload');
        } else {
          safeCall(vid, 'pause');
        }
      });
    }

    function preloadAdjacent(idx) {
      var total = allSlides.length;
      if (total <= 1) return;
      [(idx - 1 + total) % total, (idx + 1) % total].forEach(function (i) {
        safeCall(getVideo(allSlides[i]), 'load');
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (activeIndex > 0) {
          var newIdx = activeIndex - 1;
          preloadAdjacent(newIdx);
          updatePositions(newIdx);
          updateMuteIcons();
          trackPlay(newIdx);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (activeIndex < allSlides.length - 1) {
          var newIdx = activeIndex + 1;
          preloadAdjacent(newIdx);
          updatePositions(newIdx);
          updateMuteIcons();
          trackPlay(newIdx);
        }
      });
    }

    /* ---- Mobile observer ---- */

    function setupMobileObserver() {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var vid = getVideo(entry.target);
          if (!vid) return;
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            var idx = parseInt(entry.target.dataset.slideIndex, 10) || 0;
            if (idx !== activeIndex) {
              activeIndex = idx;
              updateMuteIcons();
              trackPlay(idx);
            }
            safeCall(vid, 'play');
          } else {
            safeCall(vid, 'pause');
          }
        });
      }, { root: slides, threshold: 0.6 });
      allSlides.forEach(function (slide) { observer.observe(slide); });
    }

    /* ---- Open / Close ---- */

    function resetAtcButtons() {
      dialog.querySelectorAll('[data-sv-atc]').forEach(function (btn) {
        if (!btn.dataset.svOriginal) return;
        var label = btn.querySelector('[data-sv-atc-label]');
        if (label) label.textContent = btn.dataset.svOriginal;
        btn.disabled = false;
        btn.classList.remove('psv-dialog__atc--added');
      });
    }

    function openDialog(startIndex) {
      activeIndex = startIndex;

      if (isDesktop()) {
        slides.classList.add('psv-no-transition');
        allSlides.forEach(function (slide, i) {
          var diff = i - startIndex;
          slide.dataset.position = diff === 0 ? 'center' : diff === -1 ? 'left' : diff === 1 ? 'right' : 'hidden';
        });
      }

      dialog.showModal();
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () {
        if (isDesktop()) {
          /* eslint-disable no-unused-expressions */
          slides.offsetHeight;
          /* eslint-enable no-unused-expressions */
          slides.classList.remove('psv-no-transition');
          preloadAdjacent(startIndex);
          updatePositions(startIndex);
        } else {
          for (var i = Math.max(0, startIndex - 1); i <= Math.min(allSlides.length - 1, startIndex + 1); i++) {
            safeCall(getVideo(allSlides[i]), 'load');
          }
          slides.scrollTop = startIndex * slides.clientHeight;
          setupMobileObserver();
          safeCall(getVideo(allSlides[startIndex]), 'play');
        }
        updateMuteIcons();
        trackPlay(startIndex);
      });
    }

    function closeDialog() {
      if (observer) { observer.disconnect(); observer = null; }
      dialog.querySelectorAll('spectrum-video').forEach(function (v) { safeCall(v, 'unload'); });
      resetAtcButtons();
      try { dialog.close(); } catch (e) {}
      document.body.style.overflow = '';
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        openDialog(parseInt(card.dataset.svIndex, 10) || 0);
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDialog);
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog();
    });

    dialog.addEventListener('cancel', function () {
      if (observer) { observer.disconnect(); observer = null; }
      dialog.querySelectorAll('spectrum-video').forEach(function (v) { safeCall(v, 'unload'); });
      resetAtcButtons();
      document.body.style.overflow = '';
    });

    /* ---- Add to cart ---- */

    function attachAtcListener(btn) {
      if (!btn.dataset.svOriginal) {
        var label = btn.querySelector('[data-sv-atc-label]');
        btn.dataset.svOriginal = label ? label.textContent : 'Add to cart';
      }

      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        var label = btn.querySelector('[data-sv-atc-label]');
        var Spectrum = window.Spectrum;
        if (!Spectrum || !Spectrum.cart || typeof Spectrum.cart.add !== 'function') {
          console.warn('[psv] Spectrum.cart.add unavailable');
          return;
        }

        btn.disabled = true;
        if (label) label.textContent = 'Adding...';

        Spectrum.cart.add({ id: parseInt(variantId, 10), quantity: 1 })
          .then(function (res) {
            if (res && res.ok === false) { throw new Error('Add failed'); }
            var entity = entityFromAtcButton(btn);
            trackEvent('shoppable_video_atc', Object.assign({}, entity, {
              quantity: 1,
              videoUrl: btn.dataset.videoUrl || '',
              __spectrumVariant: 'spectrum-ai'
            }));
            if (label) label.textContent = 'Added';
            btn.classList.add('psv-dialog__atc--added');

            /* THEME-SPECIFIC: Bozeman cart drawer refresh + open.
               Mirrors theme.js .grid-add-to-cart-btn handler:
               cart_drawer() refreshes markup, then drawer_is_open + stop_page_scroll. */
            closeDialog();
            try {
              if (typeof window.cart_drawer === 'function') {
                window.cart_drawer();
              }
              if (window.jQuery) {
                window.jQuery('.cart_drawer').addClass('drawer_is_open');
                window.jQuery('html body').addClass('stop_page_scroll');
              }
            } catch (e) {}
            /* END THEME-SPECIFIC */

            setTimeout(function () {
              btn.disabled = false;
              btn.classList.remove('psv-dialog__atc--added');
              if (label) label.textContent = btn.dataset.svOriginal || 'Add to cart';
            }, 1400);
          })
          .catch(function (err) {
            console.error('[psv] cart add failed', err);
            if (label) label.textContent = 'Try again';
            setTimeout(function () {
              btn.disabled = false;
              if (label) label.textContent = btn.dataset.svOriginal || 'Add to cart';
            }, 1800);
          });
      });
    }

    dialog.querySelectorAll('[data-sv-atc]').forEach(attachAtcListener);
  }

  function initAll() {
    document.querySelectorAll('[data-psv]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-psv]');
    if (s) initSection(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (section.dataset.proSpotlightInit === '1') return;
    section.dataset.proSpotlightInit = '1';

    var track = section.querySelector('[data-pro-spotlight-track]');
    var slides = section.querySelectorAll('[data-pro-spotlight-slide]');
    var dots = section.querySelectorAll('[data-pro-spotlight-dot]');
    if (!track || !slides.length) return;

    function setActiveDot(idx) {
      Array.prototype.forEach.call(dots, function (d, i) {
        var active = i === idx;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function getSnapPadding() {
      var cs = getComputedStyle(track);
      return parseFloat(cs.scrollPaddingLeft) || parseFloat(cs.paddingLeft) || 0;
    }

    function isCenterSnap() {
      var first = slides[0];
      if (!first) return false;
      return getComputedStyle(first).scrollSnapAlign === 'center';
    }

    function getCardStep() {
      if (slides.length < 2) return slides[0] ? slides[0].getBoundingClientRect().width : 0;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    // Each dot maps to a discrete scroll position (one card-step apart).
    // Number of useful dots collapses to (slides.length) when every slide can
    // become the leftmost-visible card, and shrinks otherwise.
    function pageCount() {
      if (slides.length <= 1) return 1;
      var step = getCardStep();
      var maxScroll = getMaxScroll();
      if (step <= 0 || maxScroll <= 0) return 1;
      return Math.min(slides.length, Math.ceil(maxScroll / step) + 1);
    }

    function dotScrollLeft(i) {
      var step = getCardStep();
      var maxScroll = getMaxScroll();
      return Math.min(i * step, maxScroll);
    }

    function applyDotVisibility() {
      var n = pageCount();
      Array.prototype.forEach.call(dots, function (d, i) {
        d.style.display = i < n ? '' : 'none';
      });
    }

    function activeDotForScroll() {
      var n = pageCount();
      if (n <= 1) return 0;
      var step = getCardStep();
      var sl = track.scrollLeft;
      var idx = Math.round(sl / step);
      if (idx < 0) idx = 0;
      if (idx > n - 1) idx = n - 1;
      return idx;
    }

    function nearestSlideIndex() {
      var trackRect = track.getBoundingClientRect();
      var anchor;
      if (isCenterSnap()) {
        anchor = trackRect.left + trackRect.width / 2;
      } else {
        anchor = trackRect.left + getSnapPadding();
      }
      var bestIdx = 0;
      var bestDist = Infinity;
      Array.prototype.forEach.call(slides, function (s, i) {
        var r = s.getBoundingClientRect();
        var ref = isCenterSnap() ? r.left + r.width / 2 : r.left;
        var d = Math.abs(ref - anchor);
        if (d < bestDist) { bestDist = d; bestIdx = i; }
      });
      return bestIdx;
    }

    function scrollToIndex(i, smooth) {
      var target = slides[i];
      if (!target) return;
      var trackRect = track.getBoundingClientRect();
      var slideRect = target.getBoundingClientRect();
      var delta;
      if (isCenterSnap()) {
        delta = (slideRect.left + slideRect.width / 2) - (trackRect.left + trackRect.width / 2);
      } else {
        delta = (slideRect.left - trackRect.left) - getSnapPadding();
      }
      track.scrollTo({
        left: Math.max(0, track.scrollLeft + delta),
        behavior: smooth === false ? 'auto' : 'smooth'
      });
    }

    function setActiveSlide() {
      var idx = nearestSlideIndex();
      Array.prototype.forEach.call(slides, function (s, i) {
        s.classList.toggle('is-active', i === idx);
        if (i < idx) {
          s.style.transformOrigin = 'right center';
        } else if (i > idx) {
          s.style.transformOrigin = 'left center';
        } else {
          s.style.transformOrigin = 'center center';
        }
      });
    }

    var scrollRaf = 0;
    track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = 0;
        setActiveDot(activeDotForScroll());
        setActiveSlide();
      });
    }, { passive: true });

    Array.prototype.forEach.call(dots, function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-target'), 10) || 0;
        var n = pageCount();
        if (i > n - 1) i = n - 1;
        track.scrollTo({ left: dotScrollLeft(i), behavior: 'smooth' });
        setActiveDot(i);
      });
    });

    applyDotVisibility();
    window.addEventListener('resize', applyDotVisibility);

    function stepTo(i) {
      var n = pageCount();
      if (i < 0) i = 0;
      if (i > n - 1) i = n - 1;
      track.scrollTo({ left: dotScrollLeft(i), behavior: 'smooth' });
      setActiveDot(i);
    }
    function nextStep() { stepTo(activeDotForScroll() + 1); }
    function prevStep() { stepTo(activeDotForScroll() - 1); }

    var startX = 0;
    var startY = 0;
    var dragging = false;
    var moved = false;
    var THRESHOLD = 40;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
        moved = true;
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      var dx = (e.clientX || 0) - startX;
      if (moved && Math.abs(dx) > THRESHOLD) {
        if (dx < 0) nextStep(); else prevStep();
      }
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', function () { dragging = false; });
    track.addEventListener('pointerleave', function (e) { if (dragging) endDrag(e); });

    track.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    setActiveDot(0);
    setActiveSlide();
  }

  function initAll() {
    document.querySelectorAll('[data-pro-spotlight]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pro-spotlight]');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pro-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (section.dataset.proVideoInit === '1') return;
    section.dataset.proVideoInit = '1';

    var sv = section.querySelector('spectrum-video');
    var toggle = section.querySelector('[data-pro-video-toggle]');
    if (!sv || !toggle) return;

    function syncState(paused) {
      section.dataset.paused = paused ? 'true' : 'false';
      toggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    toggle.addEventListener('click', function () {
      var inner = sv.querySelector('video');
      var paused = inner ? inner.paused : section.dataset.paused === 'true';
      if (paused) {
        if (typeof sv.play === 'function') sv.play();
        syncState(false);
      } else {
        if (typeof sv.pause === 'function') sv.pause();
        syncState(true);
      }
    });

    sv.addEventListener('spectrum-video:play', function () { syncState(false); });
    sv.addEventListener('spectrum-video:pause', function () { syncState(true); });

    syncState(false);
  }

  function initAll() {
    document.querySelectorAll('[data-pro-video]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pro-video]');
    if (s) initSection(s);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
